import UserAddFormModal from './UserAddFormModal.view';
export default UserAddFormModal;
